import React from "react";
import { Trans, withI18n, getI18n } from "react-i18next";
import styled, { css } from "styled-components";
import { connect } from "react-redux";
import { iRootState } from "../../../store";
import { Typography, Button, TextInput } from "components/Common";
import HeroImageFile from "../../../images/hero-jpg.jpg";
import LogoTWB from "../../../images/icon-twb-logo-full.svg";
import SendIcon from "../../../images/send.svg";
import BoltIcon from "../../../images/bolt.svg";
import EarthIcon from "../../../images/earth.svg";
import SpinnerIcon from "../../../images/spinner.svg";
import { emailValidation, passwordValidation } from "helpers/validations";
import { errorPageRedirect, PasswordLength, useLocalStorage } from "helpers";
import { IActorCredentials, IActorError } from "shared/api/dtos/IActorDto";
import { Spinner } from "components/Common/StyledComponents";
// @ts-ignore
import { CWBLoadingCrest } from "cwb-react";
import PasswordInput from "components/Common/PasswordInput";

interface IProps extends StateProps, DispatchProps {
  t?: any;
  history?: any;
  location?: any;
  match?: any;

  agentData: any,
  verifyInvitation: any,
}

interface IState {
  fields: IActorCredentials;
  // errors: IActorError;
  isVerificationLoading: boolean,
  isSubmitLoading: boolean,
  locationCode: string,
}

class ActorInvitation extends React.Component<IProps, IState> {
  public state: IState = {
    isVerificationLoading: true,
    isSubmitLoading: false,
    locationCode: '',

    fields: {
      email: "",
      password: ""
    } as IActorCredentials,
    // errors: this.props.errors || ({} as IActorError),
  };

  constructor(props: any) {
    super(props)
  }

  componentDidMount() {
    this.loadAgentData();
  }

  loadAgentData = async () => {
    const response = await this.props.verifyInvitation(this.props.match.params.id);
    if (
      response.status !== 200
      || response.data.notFound
      || !response.data.isValid
    ) {
      window.location.href = `/not-available?custom=invitation`;
    } else {
      this.setState({
        isVerificationLoading: false,
        locationCode: response.locationCode,
      });
    }
  }

  checkValidation() {
    const { t } = this.props;
    let fields = this.state.fields;
    let errors: IActorError = {} as IActorError;

    if (emailValidation(fields.email, t))
      errors.Email = emailValidation(fields.email, t);

    if (passwordValidation(fields.password, PasswordLength, t))
      errors.Password = passwordValidation(fields.password, PasswordLength, t);

    this.props.setErrors(errors);
    return Object.entries(errors).length === 0 && errors.constructor === Object;
  }

  createAccount = async (e: any) => {
    e.preventDefault();
    this.setState({ isSubmitLoading: true });
    let fields = this.state.fields;
    if (!this.checkValidation()) {
      this.setState({ isSubmitLoading: false });
      return;
    }

    this.props.setActorCredentials(fields);
    await this.props.createActorAccount(fields);

    if (this.props.errors.Email || this.props.errors.Password) {
      this.setState({ isSubmitLoading: false });
      return;
    }

    this.props.setEmailVerified(false);
    this.moveToNext();
  }

  handleChange = (e: any) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({ fields });
    // this.state.isFormSubmitClicked && this.checkValidation();
  };

  moveToNext = () => {
    if (this.props.errors.errorMessage)
      errorPageRedirect();
    else if (
      !this.props.errors ||
      (Object.entries(this.props.errors).length === 0 &&
        this.props.errors.constructor === Object)
    ) {
      const search = this.props.location.search
        ? this.props.location.search + `&ac=true&ag=${this.props.agentData.agentId}&aPath=${this.props.match.params.id}`
        : `?ac=true&ag=${this.props.agentData.agentId}&aPath=${this.props.match.params.id}`
      // &ag={agentId}

      this.props.history.push({
        pathname: `/actor/1`,
        search,
      });
    }
  }

  render() {
    const { t } = this.props;
    const isShowUSContent = this.state.locationCode === "US" && getI18n().language === "en";

    if (this.state.isVerificationLoading) {
      return (
        <LoadingWrapper>
          <CWBLoadingCrest customLogoSrc="/images/icon-twb-logo-grey.svg" />
        </LoadingWrapper>
      );
    }

    return (
      <Wrapper>
        <HeroWrapper>
          <HeroImage src={HeroImageFile}/>
        </HeroWrapper>
        <WelcomePage>
          <Header>
            <CompanyLogo src={LogoTWB} />
          </Header>
          <H1>{t('Your agent')} {this.props.agentData.firstName} {this.props.agentData.lastName} {t('is inviting you to join')} <span style={{ fontWeight: 600 }}>the</span>Workbook</H1>
          
          {getI18n().language.startsWith('es')
            ? <Typography style={{ textAlign: 'center' }}>¡Enhorabuena, vas a formar parte de theWorkook!</Typography>
            : null
          }

          {isShowUSContent
            ? <LeadText>
                <Trans i18nKey="whereAllTheirUSTalent">Where all their U.S talent receive free submissions & self tapes - <b>for life</b></Trans>
              </LeadText>
            : null
          }
          <AgencyLogoWrapper>
            <AgencyLogo src={this.props.agentData.logoUrl}/>
            <AgentLogoLabel>{this.props.agentData.company}</AgentLogoLabel>
          </AgencyLogoWrapper>
          {/* <Typography style={{ marginBottom: 48, textAlign: 'center' }}>Agency name</Typography> */}
          <Form onSubmit={this.createAccount}>
            <TextInputWrapper>
              <TextInputLabel>{t('Email address')}</TextInputLabel>
              <TextInput
                onChange={this.handleChange}
                name='email'
                value={this.state.fields.email}
                // hideLabel
              />
              {this.props.errors.Email && (
                <ErrorText>
                  {this.props.errors.Email}
                </ErrorText>
              )}
            </TextInputWrapper>
            <TextInputWrapper>
              <TextInputLabel>{t('Password')}</TextInputLabel>
              {/* <TextInput
                onChange={this.handleChange}
                name='password'
                value={this.state.fields.password}
                // hideLabel
                type='password'
                style={{ marginBottom: 2 }}
                autoComplete="new-password"
              /> */}
              <PasswordInput
                onChange={this.handleChange}
                name='password'
                value={this.state.fields.password}
                // hideLabel
                // type='password'
                style={{ marginTop: 0 }}
                autoComplete="new-password"
              />
              {this.props.errors.Password && (
                <ErrorText>
                  {this.props.errors.Password}
                </ErrorText>
              )}
              {this.props.errors.Password
                ? null
                : <Typography style={{ color: 'rgb(129, 133, 140)', textAlign: 'center', fontSize: 12, marginBottom: 16 }}>{t('Must contain at least 6 characters, 1 letter and 1 number')}</Typography>
              }
            </TextInputWrapper>
            <ButtonStyled
              type="submit"
              disabled={this.state.isSubmitLoading}
            >
              {t('Continue')}
              {this.state.isSubmitLoading && (
                <Spinner
                  src="../images/spinner.svg"
                  className="spinner-width"
                />
              )}
            </ButtonStyled>
          </Form>
          <SignUpText>
            <Trans i18nKey="bySigningUpYouAgree">By signing up you agree yo our <a href={`${process.env.REACT_APP_CWB_Site}/terms_conditions.asp`}>Terms of Use</a> and <a href={`${process.env.REACT_APP_CWB_Site}/privacy.asp`}>Privacy Policy</a></Trans>
          </SignUpText>
          <PerkList>
            {isShowUSContent
              ? <Perk>
                  <PerkIcon src={SendIcon} />
                  <PerkText>{t('Free submissions US Forever')}</PerkText>
                </Perk>
              : null
            }
            <Perk>
              <PerkIcon src={BoltIcon} />
              <PerkText>{t('Most powerful tools for any service')}</PerkText>
            </Perk>
            <Perk>
              <PerkIcon src={EarthIcon} />
              <PerkText>{t('Members in 100+ countries')}</PerkText>
            </Perk>
          </PerkList>
          <InfoText>
            <Trans i18nKey="alreadyHaveAnAccountLogIn">Already have an account? <a href={`${process.env.REACT_APP_CWB_Site}/login?ac=true&aPath=${this.props.match.params.id}`}>Log in</a></Trans>
          </InfoText>
          <InfoText style={{ color: 'rgb(129, 133, 140)', fontSize: 12 }}>
            {t(
              'By logging in from here {{name}} will be automatically added to your account',
              { name: this.props.agentData.firstName },
            )}
          </InfoText>
        </WelcomePage>
      </Wrapper>
    );
  }
}


const container = css`
  max-width: 540px;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  background-color: white;
  height: 100vh;
  width: 100%;
  @media(min-width: 960px) {
    display: flex;
    flex-flow: nowrap row;
  }
`;

const HeroWrapper = styled.div`
  display: none;
  @media(min-width: 960px) {
    display: inline-block;
    flex: 1;
    height: 100%;
  }
`;

const WelcomePage = styled.div`
  height: 100%;
  overflow: auto;
  padding-bottom: 32px;
  @media(min-width: 960px) {
    flex: 1;
  }
`;

const HeroImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

const Header = styled.header`
  padding: 32px 16px;
  margin-bottom: 24px;
  @media(min-width: 960px) {
    padding: 32px;
    display: flex;
    flex-flow: nowrap row;
    justify-content: end;
    // margin-bottom: 48px;
  }
`;

const CompanyLogo = styled.img`
  height: 44px;
`;

const H1 = styled(Typography).attrs({
  variant: 'h1',
})`
  width: 80%;
  // padding: 0 48px;
  text-align: center;
  line-height: 32px;
  ${container};
  margin-bottom: 16px;
  font-size: 20px;
  line-height: 28px;

  @media(min-width: 960px) {
    margin-bottom: 16px;
  }
`;

const LeadText = styled(Typography)`
  width: 75%;
  margin: 0 auto;
  // padding: 0 48px;
  text-align: center;
  font-size: 16px;
  line-height: 23px;
  ${container};

  @media(min-width: 960px) {
    // font-size: 18px;
    max-width: 360px;
  }
`;

const TextInputWrapper = styled.div`
  margin-bottom: 12px;
`;

const TextInputLabel = styled.div`
  font-size: ${(p) => p.theme["xxs-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  color: ${(p) => p.theme.color} !important;
  line-height: 16px;
  margin-bottom: 8px;
`;

const AgencyLogoWrapper = styled.div`
  position: relative;
  height: 80px;
  margin: 16px 16px 48px;
`;

const AgencyLogo = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  max-width: 100%;
  object-fit: contain;
`;

const AgentLogoLabel = styled(Typography)`
  position: absolute;
  bottom: -26px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
`;

const Form = styled.form`
  padding: 0 16px;
  margin-bottom: 16px;
  ${container};
`;

const PerkList = styled.ul`
  display: flex;
  flex-flow: nowrap row;
  list-style: none;
  padding: 16px;
  gap: 8px;
  justify-content: center;
 
  @media(min-width: 960px) {
    margin-bottom: 32px;
  }
`;

const Perk = styled.li`
  display: flex;
  flex-flow: nowrap column;
  background-color: #F9FAFC;
  padding: 12px 6px 6px;
  align-items: center;
  max-width: 110px;
  width: 30%;
  border-radius: 4px;

  // & > *{
  //   opacity: .8;
  // }
`;

const PerkIcon = styled.img`
  height: 18px;
  width: auto;
  margin-bottom: 8px;
`;

const PerkText = styled(Typography)`
  color: #333333;
  font-size: 9px;
  font-weight: bold;
  line-height: 13px;
  text-align: center;
`;

const InfoText = styled(Typography)`
  font-size: 14px;
  text-align: center;
  ${container};
  margin-bottom: 4px;
  padding: 0 16px;
  & > a{
    &,
    &:link,
    &:visited{
      color: #0F9BF0;
      font-weight: bold;
    }
  }
`;

const SignUpText = styled(InfoText)`
  margin-bottom: 32px;
`;

const ErrorText = styled(Typography)`
  color: ${(p) => p.theme.errorColor} !important;
  width: 100%;
  font-size: ${(p) => p.theme["xxs-font-size"]} !important;
  font-weight: normal;
  letter-spacing: 0.21px;
  line-height: 15px;
  margin-top: 8px;
  a {
    font-size: ${(p) => p.theme["xxs-font-size"]} !important
  }
  span{
    font-size: ${(p) => p.theme["xxs-font-size"]} !important
    font-weight: normal;
  }
`;

const LoadingWrapper = styled.div`
  background-color: white;
  width: 100vw;
  height: 100vh;
`;

const ButtonStyled = styled(Button)`
  width: 100%;
  height: 37px;
  font-size: 13px;
  font-weight: 600;
  background-color: ${(p) => p.theme.palette.brand.lightBlue};
  margin-bottom: 8px;

  &:hover {
    background-color: ${(p) => p.theme.palette.brand.blue};
  }

  &:active {
    background-color: ${(p) => p.theme.palette.brand.darkBlue};
  }
  &:disabled {
    pointer-events: none;
  }
`;



interface StateProps {
  agentData: any,
  errors: IActorError;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    agentData: state.invitationModel.agentData,
    errors: state.actorModel.errors,
  };
}

interface DispatchProps {
  verifyInvitation: (path: string) => void;
  createActorAccount: (fields: any) => void;
  setErrors: (errors: any) => void;
  setActorCredentials: (actorCredentials: any) => void;
  setEmailVerified: (isEmailVerified: boolean) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    verifyInvitation: dispatch.invitationModel.verifyInvitation,
    createActorAccount: dispatch.actorModel.createActorAccount,
    setErrors: dispatch.actorModel.setErrors,
    setActorCredentials: dispatch.actorModel.setActorCredentials,
    setEmailVerified: dispatch.actorModel.setEmailVerified,
  };
}

export default withI18n()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ActorInvitation)
);
